<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Config Misc & Other Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn class="mb-2 mr-2 mt-2" rounded color="success" small tile @click="openFileSelector()">
                    <v-icon class="mr-2" small>mdi-file-import</v-icon>import Misc Fees
                </v-btn>
            </v-toolbar>
            <v-data-table id="miscFeesTable" :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"
                @current-items="getFiltered">
                <template v-slot:top>
                    <!-- filter code added -->
                    <template class="pb-5">
                        <v-row>
                            <v-col cols="12" sm="2" md="1"></v-col>
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                            
                        </v-row>
                        <v-row align="center" class="search-action-row">

  
                        <v-col cols="12" md="4" sm="4" class="d-flex align-center">

                        <v-btn
                            rounded
                            color="success"
                            outlined
                            :loading="loader"
                            @click="downloadFile"
                            class="mr-2"
                        >
                            <v-icon left color="success">mdi-export</v-icon>
                            Export
                        </v-btn>

                        <v-btn
                            rounded
                            color="success"
                            @click="printPDF('miscFeesTable')"
                        >
                            <v-icon left>mdi-file-pdf-box</v-icon>
                            PDF
                        </v-btn>

                    </v-col>

                    <v-col cols="12" md="4" sm="4">

                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>

                    </v-col>

                    <v-col cols="12" md="4" sm="4" class="d-flex justify-end align-center">
                        <v-btn class="button" @click="dialog='true'">
                            Add Misc/Other Fees
                        </v-btn>
                    </v-col>

                </v-row>
                    </template>
                   
                        <!-- <v-spacer></v-spacer> -->
                        <!-- <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field> -->
        
                        <v-dialog v-model="dialog" max-width="500px">
                            <!-- <v-col v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Misc/Other Fees</v-btn>
                            </v-col> -->
                            <!-- <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Misc/Other Fees</v-btn>
                            </template> -->
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined :items="academic_year_list"
                                                    item-text="ay" item-value="id" v-model="addedItem.academic_year"
                                                    label="Select Academic Year"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined :items="misc_fees_master_list"
                                                    item-text="misc_fees_master" item-value="id"
                                                    v-model="addedItem.misc_fees_master"
                                                    label="Select Misc. Fees"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded multiple outlined :items="standard_list"
                                                    item-text="std" item-value="id" v-model="addedItem.std"
                                                    label="Select standard"></v-autocomplete>
                                            </v-col>
                                            <!-- <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                Add Division Wise Misc Fee <v-switch
                                                    v-model="add_div_off_toggle"
                                                    @change="onDivisionToggle"
                                                ></v-switch>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12"
                                                v-if="editedIndex == -1 && isStudentSpecific">
                                                Add Student Wise Misc Fee
                                                <v-switch
                                                    v-model="add_student_off_toggle"
                                                    @change="onStudentToggle"
                                                ></v-switch>
                                            </v-col> -->
                                           <v-row v-if="editedIndex == -1">
                                                <v-col cols="12" sm="6" md="6">
                                                    <div class="text-center">
                                                        <span>Add Division Wise Misc Fee</span>

                                                        <v-switch class="ma-0 pa-0 d-flex justify-center" hide-details
                                                            v-model="add_div_off_toggle"
                                                            @change="onDivisionToggle"></v-switch>
                                                    </div>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6" v-if="isStudentSpecific">
                                                    <div class="text-center">
                                                        <span>Add Student Wise Misc Fee</span>

                                                        <v-switch class="ma-0 pa-0 d-flex justify-center" hide-details
                                                            v-model="add_student_off_toggle"
                                                            @change="onStudentToggle"></v-switch>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-col cols="12" sm="12" md="12"
                                                v-if="editedIndex == -1 && div_off_list!='' && add_div_off_toggle==true">
                                                <v-autocomplete dense rounded outlined :items="div_off_list"
                                                    item-text="div_name" item-value="div_of_id"
                                                    v-model="addedItem.divisionoffering"
                                                    label="Select Division"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="
                                                editedIndex == -1 &&
                                                add_student_off_toggle == true
                                            ">
                                               <v-autocomplete dense rounded outlined multiple :items="student_list"
                                                    item-text="name" item-value="prn"
                                                    v-model="addedItem.students"
                                                    label="Select Students"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field dense rounded outlined readonly
                                                    v-model="editedItem.academic_year" label="Academic Year"
                                                    hint="Non editable"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field dense rounded outlined readonly
                                                    v-model="editedItem.misc_fees_master" label="Misc. Fees"
                                                    hint="Non editable"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field dense rounded outlined readonly
                                                    v-model="editedItem.standard" label="Standard"
                                                    hint="Non editable"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-text-field dense type="number" rounded outlined
                                                    hint="For example :: 1000, 2000" v-model="addedItem.fees_ammount"
                                                    label="Enter Fees Amount"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field v-model="editedItem.fees_ammount" dense type="number"
                                                    rounded outlined persistent-hint hint="For example :: 1000, 2000"
                                                    label="Fees Component"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>

              <v-dialog v-model="import_dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                    <span class="headline mb-5">Import Misc Fees</span>
                    <v-spacer></v-spacer>
                    <v-btn small color="success" @click="generateExcel" class="mb-5">
                    Download Excel Template
                    </v-btn>
                    </v-card-title>

                    <v-card-text>
                    <v-file-input
                        v-model="file"
                        label="Select CSV File"
                        prepend-icon="mdi-file"
                        outlined
                        rounded
                        dense
                        show-size
                    ></v-file-input>
                    </v-card-text>

                    <v-card-actions class="justify-center">
                    <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" @click="importMiscFees" :disabled="!file">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          overlay: false,
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          errorMsg: {
              fees_ammount: false,
          },
          snackbar_msg: "",
          color: "",
          snackbar: false,
          search: "",
          dialog: false,
          fees_ammount: null,
          misc_fees_master_list: null,
          standard_list: null,
          std: null,
          add_student_off_toggle: false,
          file:null,
          import_dialog:false,
          student_list: [],
          academic_year_list: [],
          filterArr: [],
          filters: {
              academic_year: [],
              standard: [],
              // subject: [],
          },
          headers: [
              {
                  text: "Sr. No.",
                  align: "left",
                  sortable: false,
                  value: "srno",
              },
              {
                  text: "Misc/Other Fees",
                  align: "left",
                  sortable: false,
                  value: "misc_fees_master",
              },
              {
                  text: "Learner",
                  align: "left",
                  sortable: false,
                  value: "learner",
              },
              {
                  text: "Academic Year",
                  align: "left",
                  sortable: false,
                  value: "academic_year",
              },
              {
                  text: "Standard",
                  align: "left",
                  sortable: false,
                  value: "standard",
              },
              {
                  text: "Division",
                  align: "left",
                  sortable: false,
                  value: "divisionoffering",
              },
              {
                  text: "Ammount",
                  align: "left",
                  sortable: false,
                  value: "fees_ammount",
              },
              {
                  text: "Active",
                  align: "left",
                  sortable: true,
                  value: "isactive",
              },
              { text: "Actions", value: "action", sortable: false },
          ],
          misc_other_fees_list: [],
          div_off_list: [],
          editedIndex: -1,
          add_div_off_toggle:false,
          addedItem: {
              fees_ammount: "",
              misc_fees_master: null,
              std: null,
              academic_year: null,
              divisionoffering: null,
              students: [],
          },
          editedItem: {
              id: "",
              fees_ammount: "",
              misc_fees_master: null,
              isactive: true,
              academic_year: null,
              divisionoffering: null,
          },
          defaultItem: {
              id: "",
              fees_ammount: "",
              isactive: true,
              academic_year: null,
              divisionoffering: null,
          },
            fieldNames: ["PRN", "Academic Year", "Misc Fees Name",  "Amount"]
      }),

      computed: {
          formTitle() {
              return this.editedIndex === -1 ? "New Misc./Other Fees" : "Edit Misc./Other Fees";
          },
          selectedMiscFee() {
            if (!this.misc_fees_master_list) {
                return null;
            }

            return this.misc_fees_master_list.find(
                x => x.id == this.addedItem.misc_fees_master
            );
          },

          isStudentSpecific() {
            if (!this.selectedMiscFee) {
                return false;
            }

            return this.selectedMiscFee.is_student_specific === true;
          },


          bookList1() {
              return this.misc_other_fees_list.filter((d) => {
                  return Object.keys(this.filters).every((f) => {
                      return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                  });
              });
          },
      },

      watch: {
          dialog(val) {
              val || this.close();
          },
          overlay(val) {
              val = () => {
                  this.overlay = false;
              };
          },
      },

      // created () {
      //   this.initialize()
      // },
      mounted() {
          this.onLoad();
      },
      methods: {
       downloadFile() {
      this.loader = true;

      const excelData = this.misc_other_fees_list.map((item, index) => ({
        "Sr.No": index + 1,
        "Misc/Other Fees": item.misc_fees_master,
        "Learner": item.learner,
        "Academic Year": item.academic_year,
        "Standard": item.standard,
        "Division": item.divisionoffering,
        "Amount": item.fees_ammount,
        "Status": item.isactive ? "Active" : "Inactive"
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "MiscAndOtherFees");
      XLSX.writeFile(workbook, "MiscAndOtherFees.xlsx");

      this.loader = false;
    },
    printPDF(id) {

    var tableContainer = document.getElementById(id);

    if (!tableContainer) {
        console.error("Table not found");
        return;
    }
    var table = tableContainer.querySelector("table");

    if (!table) {
        console.error("Table element not found");
        return;
    }

    var tableClone = table.cloneNode(true);

    var rows = tableClone.querySelectorAll("tr");

    rows.forEach(function(row) {
        if (row.lastElementChild) {
            row.removeChild(row.lastElementChild);
        }
    });
    var bodyRows = tableClone.querySelectorAll("tbody tr");

    bodyRows.forEach(function(row) {

        var cells = row.querySelectorAll("td");

        if (cells.length > 0) {

            var activeCell = cells[cells.length - 1];

            var switchElement =
                activeCell.querySelector(".v-input--selection-controls");

            if (switchElement) {

                var isActive =
                    activeCell.querySelector(".v-input--is-focused") ||
                    activeCell.querySelector(".v-input--selection-controls__ripple");

                var checkbox =
                    activeCell.querySelector("input[type='checkbox']");

                if (checkbox) {
                    activeCell.innerHTML =
                        checkbox.checked ? "Active" : "Inactive";
                }
            }
        }
    });

    var win = window.open(
        '',
        '',
        'height=700,width=1000'
    );

    win.document.write(`
        <html>
        <head>

        <title>Misc & Other Fees</title>

        <style>

            @page {
                size: A4 landscape;
                margin: 8mm;
            }

            body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
            }

            .report-title {
                text-align: center;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 15px;
            }

            table {
                width: 100%;
                border-collapse: collapse;
                table-layout: auto;
                font-size: 10px;
            }

            th {
                border: 1px solid black;
                padding: 6px;
                text-align: center;
                font-weight: bold;
                background: #0f2027;
                color: white;
            }

            td {
                border: 1px solid black;
                padding: 6px;
                text-align: center;
                word-break: break-word;
            }

            thead {
                display: table-header-group;
            }

            tr {
                page-break-inside: avoid;
            }

        </style>

        </head>

        <body>

            <div class="report-title">
                Misc & Other Fees
            </div>

            ${tableClone.outerHTML}

        </body>
        </html>
    `);

    win.document.close();
    win.focus();

    setTimeout(function() {
        win.print();
        win.close();
    }, 500);
},


          getFiltered(e) {
              this.filterArr = e;
          },
          columnValueList(val) {
              return this.misc_other_fees_list.map((d) => d[val]);
          },
          initializeErrorMsgFalse() {
              this.errorMsg.fees_ammount = false;
          },
          toggle(item) {
              const mod = {
                  misc_fees_id: item.id,
                  isactive: item.isactive,
              };
              axios
                  .post("/MiscAndOtherFees/toggleMiscFees", mod)
                  .then((res) => {
                      if (res.data.status.code == "SUCCESS") {
                          this.showSnackbar("#4caf50", "Misc./Other Fees status updated successfully...");
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {
                      //overlay->loader
                  });
          },
          onLoad() {
              this.overlay = true;
              axios
                  .post("/MiscAndOtherFees/getMiscOtherFees")
                  .then((res) => {
                      if (res.data.msg == "200") {
                          this.overlay = false;
                          // this.academicYear = res.data.academicYear;
                          this.misc_other_fees_list = res.data.misc_other_fees_list;
                          this.misc_fees_master_list = res.data.misc_fees_master_list;
                          this.standard_list = res.data.standard_list;
                          this.academic_year_list = res.data.academic_year_list;
                          this.load = true;
                      } else {
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                      window.console.log(error);
                  })
                  .finally(() => {
                      "use strict";
                      var overlay = false;
                  });
          },
          getDivisionList() {
            const data={
              academic_year:this.addedItem.academic_year,
              std:this.addedItem.std
            }
            axios
                .post("/MiscAndOtherFees/getDivisionList", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.div_off_list = res.data.div_off_list
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                   
                });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },

          editItem(item) {
              this.editedIndex = this.misc_other_fees_list.indexOf(item);
              this.editedItem = Object.assign({}, item);
              this.dialog = true;
          },

          // deleteItem (item) {
          //   const index = this.fees_ammount.indexOf(item)
          //   confirm('Are you sure you want to delete this item?') && this.fees_ammount.splice(index, 1)
          // },

          close() {
              this.dialog = false;
              setTimeout(() => {
                  this.editedItem = Object.assign({}, this.defaultItem);
                  this.editedIndex = -1;
              }, 300);
          },

          save() {
              if (this.editedIndex > -1) {
                  if (this.editedItem.fees_ammount == "") {
                      this.showSnackbar("#b71c1c", "Please enter Ammount!!!");
                      return false;
                  } else {
                      if (this.isValidated()) {
                          axios
                              .post("/MiscAndOtherFees/editMiscOtherFees", this.editedItem)
                              .then((res) => {
                                  if (res.data.msg == "200") {
                                      // Object.assign(
                                      //   this.misc_other_fees_list[this.editedIndex],
                                      //   this.editedItem
                                      // );
                                      this.onLoad();
                                      this.showSnackbar("#4caf50", "Misc./Other Fees updated successfully..."); // show snackbar on success
                                  }
                              })
                              .catch((error) => {
                                  window.console.log(error);
                              })
                              .finally(() => {
                                  this.editedItem.fees_ammount = null;
                                  this.editedItem.misc_fees_master = "";
                                  this.add_div_off_toggle=false
                              });

                          this.close();
                      }
                  }
              } else {
                  if (this.addedItem.fees_ammount == null) {
                      this.showSnackbar("#b71c1c", "Please enter Ammount!!!");
                      return false;
                  }
                  if (this.addedItem.academic_year == null) {
                      this.showSnackbar("#b71c1c", "Please select academic year!!!");
                      return false;
                  }
                  if (this.addedItem.misc_fees_master == "" || this.addedItem.misc_fees_master == null) {
                      this.showSnackbar("#b71c1c", "Please select Please select Misc./Other Fees!!!");
                      return false;
                  } else {
                      axios
                          .post("/MiscAndOtherFees/saveMiscOtherFees", this.addedItem)
                          .then((res) => {
                              if (res.data.status.code == "SUCCESS") {
                                  //   this.misc_other_fees_list.push(this.addedItem);
                                  this.showSnackbar("#4caf50", "Misc./Other Fees added successfully..."); // show snackbar on success
                                  this.onLoad();
                                  // this.addedItem.fees_ammount = "";
                                  // this.addedItem.ay = "";
                                  // this.addedItem.misc_fees_master = "";
                              } else if (res.data.status.code == "NA") {
                                  this.showSnackbar("#b71c1c", "Misc./Other Fees already present!!!");
                                  // show snackbar on error
                              }
                          })

                          .catch((error) => {
                              window.console.log(error);
                          })
                          .finally(() => {
                              this.addedItem.fees_ammount = null;
                              this.addedItem.misc_fees_master = "";
                              this.add_div_off_toggle=false
                              this.addedItem.divisionoffering = null;
                          });

                      this.close();
                  }
              }
          }, // end of save()

          isValidated() {
              if (this.editedItem.fees_ammount) {
                  return true;
              } else {
                  if (!this.editedItem.fees_ammount) {
                      this.errorMsg.fees_ammount = true;
                  }

                  return false;
              }
          }, // .....end of isValidated()

          getStudentList() {
            const data = {
                academic_year: this.addedItem.academic_year,
                std: this.addedItem.std,
                divisionoffering: this.addedItem.divisionoffering, 
            };

            axios
                .post("/MiscAndOtherFees/getStudentList", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.student_list = res.data.students_list;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },

          onDivisionToggle() {
                if (this.add_div_off_toggle) {
                    this.add_student_off_toggle = false;
                    this.addedItem.students = [];
                }

                this.getDivisionList();
            },

        onStudentToggle(val) {
            if (!this.addedItem.academic_year ||!this.addedItem.std ||this.addedItem.std.length === 0) {
                this.$nextTick(() => {
                    this.add_student_off_toggle = false
                })

                this.showSnackbar("#b71c1c","Select Academic Year and Standard")
                return
            }

            if (val) {
                this.add_div_off_toggle = false
                this.addedItem.divisionoffering = null
            }
            this.getStudentList()
        },

        openFileSelector() {
            this.import_dialog = true;
        },

        generateExcel() {
        try {
          const dataForSheet = [this.fieldNames];
          const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import Misc Fees");
          const wscols = this.fieldNames.map(() => ({ wch: 20 }));
          worksheet['!cols'] = wscols;
          XLSX.writeFile(workbook, "Misc_Fees_Import_Template.xlsx");
          
        } catch (error) {
          console.error("Error generating Excel:", error);
          alert("Failed to generate Excel file.");
        }
      },

        importMiscFees() {

            if (!this.file) {
            this.showSnackbar("#b71c1c", "Please select a file!");
            return;
            }

            const formData = new FormData();
            formData.append("file", this.file);

            this.overlay = true;

            axios.post("/MiscAndOtherFees/importMiscFees", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "EPS-token": localStorage.getItem("EPS-token"),
                "EPS-uid": localStorage.getItem("EPS-uid"),
                "router-path": this.$route.path
            }
            })
            .then((res) => {

            if (res.data.status === "SUCCESS") {
                this.showSnackbar("#4caf50", res.data.snackbar);
                this.onLoad();
            } else {
                this.showSnackbar("#b71c1c","Data Not Imported");
                this.onLoad();
            }

            this.import_dialog = false;
            this.file = null;

            })
            .catch((error) => {
            console.error("Import failed:", error);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            })
            .finally(() => {
            this.overlay = false;
            });
        },
      },
  };
</script>
<style scoped>
  .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
  }
  .v-icon-size {
      font-size: 20px;
  }
  .edit-avatar {
      transition: 0.3s;
      border: 1px solid #b0bec5;
  }
  .edit-avatar:hover {
      background-color: #b0bec5;
  }
  .edit-v-icon {
      padding-left: 6px;
      font-size: 15px;
  }
  .edit-v-icon:hover {
      color: white;
  }
  .mytable2 /deep/ thead th {
      background: #0f2027 !important; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  @media print {

    body.print-table-only * {
        visibility: hidden !important;
    }

    body.print-table-only .mytable,
    body.print-table-only .mytable * {
        visibility: visible !important;
    }

    body.print-table-only .mytable {
        position: absolute !important;
        left: 0 !important;
        top: 0 !important;
        width: 100% !important;
    }

    body.print-table-only .mytable .v-data-footer {
        display: none !important;
    }

    body.print-table-only .mytable .v-data-table__wrapper {
        overflow: visible !important;
    }

    body.print-table-only .mytable table {
        width: 100% !important;
    }
}

</style>
